/**
 * section-main-wishlist.js — Slice 29 (Wishlist) Phase 3.
 *
 * The <wishlist-page> custom element. Orchestration only: resolves its regions
 * and asks the shared helper (window.theme.wishlistCards.fill) to populate the
 * grid once on connect. Remove / add-all / quick-add are document-delegated
 * elsewhere (component-wishlist-cards.js + the loader's quickAdd surface), so
 * this element binds none of them.
 *
 * It deliberately does NOT refill on wishlist:changed: the delegated remove
 * handler mutates the DOM surgically (drops the one card + updates count +
 * empty-on-last), so a refill would trigger a redundant full re-fetch of every
 * remaining card (visible double-flash + N-1 requests). Fill once on connect;
 * removes stay surgical.
 *
 * Rules: J2 (custom element), J3/J7 (callbacks + cleanup), J5 (document events),
 * J12 (define guard).
 */
if (!customElements.get('wishlist-page')) {
  class WishlistPage extends HTMLElement {
    connectedCallback() {
      this._grid = this.querySelector('[data-wishlist-grid]');
      this._loading = this.querySelector('[data-wishlist-loading]');
      this._empty = this.querySelector('[data-wishlist-empty]');
      this._count = this.querySelector('[data-wishlist-count]');
      this._header = this.querySelector('[data-wishlist-header]');
      this._footer = this.querySelector('[data-wishlist-footer]');

      this._onReady = this._fill.bind(this);

      if (window.theme && window.theme.wishlistCards) {
        this._fill();
      } else {
        /* Defensive: shared helper not ready yet (deterministic load order makes
           this rare). Run once when it signals readiness. */
        document.addEventListener('wishlist:cards:ready', this._onReady, { once: true });
      }
    }

    disconnectedCallback() {
      document.removeEventListener('wishlist:cards:ready', this._onReady);
    }

    _fill() {
      var api = window.theme && window.theme.wishlistCards;
      if (!api || !this._grid) return;
      api.fill(this._grid, {
        loadingEl: this._loading,
        emptyEl: this._empty,
        countEl: this._count,
        headerEl: this._header,
        footerEl: this._footer
      });
    }
  }

  customElements.define('wishlist-page', WishlistPage);
}
